// extracted by mini-css-extract-plugin
export var checkmark = "features-list-module--checkmark--873b0";
export var featuresList = "features-list-module--featuresList--9e966";
export var listText = "features-list-module--listText--1673f";
export var xmark = "features-list-module--xmark--145b9";